import React from 'react'
import { AsyncState } from 'widgets-for-react'
import { getCookie } from '../../../../utils/cookies'
import { Image, ImageBase } from '../../../../utils/image'
import { ImageSize, pageheaderGenericSrc, pageheaderGenericSrcSet, pageheaderHeroSrc, pageheaderHeroSrcSet } from '../../../../utils/imageSizes'
import { SpaarneCentrumType } from '../../../../utils/spaarneIcons'
import { HeroPageHeader } from '../../../sharedLayout/pageheader'
import { PageHeaderNavLayout } from '../../../sharedLayout/pageheaderUtils'
import { ContactItem } from '../../cmsPageState'
import { Map } from 'immutable'

type CentrumPageHeaderProps = {
  title: string
  intro: string
  image?: ImageBase
  link?: { title: string; url: string }
  centrum?: { title: SpaarneCentrumType; url: string }
  videoUrl: AsyncState<string>
  contactItems: ContactItem[]
  appointmentUrl?: string
  waitingTimesUrl?: string
  breadcrumbs: { url: string; title: string }[]
  blocks: { title: string; index: number }[]
  menuItems?: { url: string; title: string; active: boolean }[]
  menuOpened?: boolean
}

export const CentrumPageHeader = (props: CentrumPageHeaderProps) => {
  return (
    <HeroPageHeader
      kind="centra-home"
      title={props.title}
      intro={props.intro}
      link={props.link}
      breadcrumbs={props.breadcrumbs}
      visual={
        props.image ? (
          <div className="pageheader__visual">
            <div className='pageheader__visual--container'>
              <div className='fit-object'>
                <Image
                  src={pageheaderHeroSrc}
                  srcset={pageheaderHeroSrcSet}
                  sizes="(min-width: 81.5rem) 1224px, 100vw"
                  lazyload={false}
                  classNames={{ image: 'pageheader__image', picture: 'pageheader__wrapper' }}
                  alt={props.image.alt}
                  urls={props.image.urls}
                  width="1220"
                  height="615"
                />
              </div>
            </div>
          </div>
        ) : props.centrum ? (
          <div className="pageheader__visual">
            <div className='pageheader__visual--container'>
              <div className='fit-object'>
                <div className="pageheader__wrapper ">
                  {props.videoUrl.kind == 'loaded' && getCookie('video-cookies') === 'yes' && props.videoUrl.value && (
                    <iframe
                      className="pageheader__iframe"
                      title="Spaarne Gasthuis"
                      src={props.videoUrl.value}
                      allow="autoplay"
                      allowFullScreen
                    />
                  )}
                  <Image
                    src={pageheaderGenericSrc}
                    srcset={pageheaderGenericSrcSet}
                    sizes="100vw"
                    lazyload={false}
                    classNames={{ image: 'pageheader__image' }}
                    alt="Spaarne Gasthuis header"
                    urls={Map<ImageSize, string>([
                      [
                        '640w', `/images/video-poster-640w.jpg`
                      ],
                      [
                        '1280w', `/images/video-poster-1280w.jpg`
                      ],
                      [
                        '1920w', `/images/video-poster-1920w.jpg`
                      ]
                    ])}
                    width="1220"
                    height="615"
                  />
                </div>
              </div>
            </div>
          </div>
        ) : undefined
      }
      topTasks={
        <PageHeaderNavLayout
          kind="centrum"
          appointmentUrl={props.appointmentUrl}
          centrumLogo={props.centrum}
          contactItems={props.contactItems}
          waitingTimesUrl={props.waitingTimesUrl}
          items={props.menuItems}
          menuOpened={props.menuOpened ?? false}
        />
      }
    />
  )
}
